import React from 'react';
import Avatar from '@mui/material/Avatar';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { Link, useParams } from 'react-router-dom';
import { api, getApiErrorMessage } from '../api';

function Profile() {
  const { id } = useParams();
  const [profile, setProfile] = React.useState(null);
  const [error, setError] = React.useState('');
  React.useEffect(() => { api.get(`/v1/profile/${id}`).then(({ data }) => setProfile(data)).catch(e => setError(getApiErrorMessage(e, 'This profile is unavailable.'))); }, [id]);
  return <main className="page-shell"><Button component={Link} to="/digipals" startIcon={<ArrowBackIcon />} sx={{ color: '#222', textDecoration: 'underline', textTransform: 'none', mb: 2 }}>Back to Digipals</Button>{error && <Alert severity="info">{error}</Alert>}{profile && <Card sx={{ maxWidth: 680 }}><CardContent sx={{ display: 'grid', justifyItems: 'center', gap: 1.5, py: 5 }}><Avatar src={profile.avatarUrl || undefined} sx={{ width: 112, height: 112, fontSize: '3rem' }}>{profile.username[0]?.toUpperCase()}</Avatar><Typography variant="h4" fontWeight="bold">{profile.username}'s Dex</Typography>{profile.myDexVisibility === 'Private' && <Typography color="text.secondary">This Dex is private.</Typography>}{profile.canViewDex && <Button className="label-button label-button-dark" component={Link} to={`/social?ownerId=${profile.id}`}>View Dex</Button>}</CardContent></Card>}</main>;
}

export default Profile;
